import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ApiResponse } from '@core/interface/api-response.interface';
import { PageableResponse } from '@core/interface/pageable.interface';
import { RefId } from '@core/interface/ref-id.interface';
import { UrlBuilder } from '@core/model/url-builder';
import { CreateManagementReportExecutionRequestDto } from '@domain/management-report-execution/dtos/create-management-report-execution.request.dto';
import { ListManagementReportExecutionRequestDto } from '@domain/management-report-execution/dtos/list-management-report-execution.request.dto';
import { ManagementReportExecutionResponseDto } from '@domain/management-report-execution/dtos/management-report-execution.response.dto';
import { PreviewManagementReportExecutionResponseDto } from '@domain/management-report-execution/dtos/preview-management-report-execution.response.dto';

@Injectable({
  providedIn: 'root',
})
export class ManagementReportExecutionService extends UrlBuilder {
  constructor(private http: HttpClient) {
    super('management/report');
  }

  list(request: ListManagementReportExecutionRequestDto) {
    const queryUrl = `${this.getApiUrl()}/execution/list`;
    return this.http.get<
      ApiResponse<PageableResponse<ManagementReportExecutionResponseDto>>
    >(queryUrl, { params: { ...request } });
  }

  show(request: RefId) {
    const { refId } = request;
    const queryUrl = `${this.getApiUrl()}/execution/show/${refId}`;
    return this.http.get<ApiResponse<ManagementReportExecutionResponseDto>>(
      queryUrl,
    );
  }

  create(request: CreateManagementReportExecutionRequestDto) {
    const queryUrl = `${this.getApiUrl()}/execution/create`;
    return this.http.post<ApiResponse<ManagementReportExecutionResponseDto>>(
      queryUrl,
      request,
    );
  }

  download(request: RefId) {
    const { refId } = request;
    const queryUrl = `${this.getApiUrl()}/execution/download/${refId}`;
    return this.http.get<ApiResponse<{ viewUrl: string }>>(queryUrl);
  }

  preview(request: RefId) {
    const { refId } = request;
    const queryUrl = `${this.getApiUrl()}/execution/preview/${refId}`;
    return this.http.get<
      ApiResponse<PreviewManagementReportExecutionResponseDto>
    >(queryUrl);
  }

  delete(request: RefId) {
    const { refId } = request;
    const queryUrl = `${this.getApiUrl()}/execution/${refId}`;
    return this.http.delete<ApiResponse<void>>(queryUrl);
  }
}
